import Button from "component/ui/Button";
import { useNavigate } from "react-router-dom";
import { CurrencyFormat } from "helper/appConstant";
import moment from "moment";
import { MdArrowForwardIos } from "react-icons/md";
import { PURCHASE_TYPE } from "helper/constant";

const Purchase = ({ data, bookingType }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div className=" mx-auto py-5">
      {/* Conditional Rendering for No Data */}
      {data?.data?.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-md text-gray-600">
            No payment history available yet.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data?.data?.map((booking) => (
            <div
              key={booking?.id}
              onClick={() =>
                navigate(`/payment-history/${booking?.id}/details`, {
                  state: booking,
                })
              }
              className="bg-gray-100 cursor-pointer p-3 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100 group border border-gray-200"
            >
              {/* Card Header with Gradient */}
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2 pb-2">
                  <div className="w-12 h-12 flex justify-center items-center text-white font-semibold rounded-full border-2 border-white shadow-md bg-highlight">
                    {booking?.sellerName &&
                      booking?.sellerName?.charAt(0)?.toUpperCase()}
                  </div>
                  <div className=" min-w-0">
                    <h3 className="text-black font-semibold text-md truncate">
                      {booking?.sellerName}
                    </h3>
                    <span className="text-highlight text-sm font-semibold">
                      {PURCHASE_TYPE[booking?.purchaseType]}{" "}
                    </span>
                  </div>
                </div>
                <MdArrowForwardIos className="h-5 w-5 cursor-pointer" />
              </div>
              <div className="bg-gradient-to-br from-white to-gray-50 border border-gray-200 md:p-3 px-1 py-2 rounded-xl shadow-sm hover:shadow-md transition-all duration-200">
                <div className="space-y-2">
                  {/* Price */}
                  <div className="flex items-center justify-between pb-1 border-b border-gray-100">
                    <div className="flex items-center gap-2">
                      <svg
                        className="w-5 h-5 text-green-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <span className="font-medium text-gray-700 text-sm">
                        Amount {bookingType == 1 ? "Paid" : "Received"}
                      </span>
                    </div>
                    <span
                      className={`text-sm font-medium ${
                        bookingType == 1 ? "text-red-600" : "text-green-600"
                      }`}
                    >
                      {CurrencyFormat(booking?.totalAmount)}
                    </span>
                  </div>

                  {/* Reschedule/Cancel */}
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <svg
                        className="w-5 h-5 text-amber-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      <span className="font-medium text-gray-700 text-sm">
                        {bookingType == 1 ? "Purchased" : "Sold"} Date
                      </span>
                    </div>
                    <span className="text-sm font-medium text-gray-900 bg-amber-50 px-3 py-1 rounded-full">
                      {moment(booking?.updatedDateTime).format("DD/MM/YYYY")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Purchase;
